'use client'
import LinkButton from '@/components/link-button'
import { Button } from '@/components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { ROUTES } from '@/constant/routes'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import { z } from 'zod'
import AuthHeader from '../components/auth-header'
import { useForgotPasswordMutation } from './request'

const formSchema = z.object({
  email: z.string().email('Invalid email provided'),
})

type FormSchemaType = z.infer<typeof formSchema>

export default function ForgotPasswordPage() {
  const form = useForm<FormSchemaType>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: '',
    },
  })

  const { isPending: isLoading, mutateAsync } = useForgotPasswordMutation()

  async function onSubmit(values: FormSchemaType) {
    await mutateAsync(values).catch((error) => {
      toast.error(error?.response?.data?.message)
    })
  }

  return (
    <section className="pt-[100px] max-sm:px-8 sm:pe-[190px] sm:ps-[100px]">
      <AuthHeader header="Forgotten Password" />
      <p className="mb-[56px] font-medium text-grey-neutral">
        Provide your registered email address below
      </p>
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="mb-10 space-y-5">
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Email Address</FormLabel>
                <FormControl>
                  <Input
                    type="email"
                    placeholder="example@revvapay.com"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <div className="!mt-20">
            <Button type="submit" size="xl" disabled={isLoading}>
              Submit
            </Button>
          </div>
        </form>
      </Form>
      <div className="flex justify-center text-grey-neutral">
        <div className="inline-flex items-center space-x-1.5">
          <p className="text-sm font-semibold">Remember Now? </p>
          <LinkButton text="Go Back" href={ROUTES.AUTH.LOGIN} variant="ghost" />
        </div>
      </div>
    </section>
  )
}
